import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { AppProvider } from './contexts/AppContext.jsx';

// BUG-001 / MOB-07: Listen for SW_UPDATED message — reload the page
// so users always see fresh assets without a manual hard-refresh.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_UPDATED') {
      console.log('[iPlanner] New SW active (' + event.data.version + ') — reloading for fresh assets');
      window.location.reload();
    }
  });
}

// BUG-002: Fix leading-zero persistence on mobile Safari number inputs.
// When a number field receives focus and its raw value is "0", clear it
// so Safari doesn't display "0" as a sticky prefix before the user's input.
document.addEventListener('focusin', (e) => {
  if (e.target.type === 'number' && (e.target.value === '0' || e.target.value === 0)) {
    e.target.value = '';
  }
});
document.addEventListener('focusout', (e) => {
  if (e.target.type === 'number' && e.target.value === '') {
    e.target.value = '0';
  }
});

// Service Worker Registration
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);
